// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logo[data-v-9d0e7566] {\n  max-width: 300px;\n  width: 100%;\n  margin-left: auto;\n  margin-right: auto;\n  padding-top: 1.5rem;\n}\n.logo img[data-v-9d0e7566] {\n  min-width: 144px;\n}", ""]);
// Exports
module.exports = exports;
